import { openDB } from 'idb';

// Initialize IndexedDB and create the required object store
export const dbPromise = openDB('CartDB', 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains('cartAssets')) {
      db.createObjectStore('cartAssets', { keyPath: 'uniqueCartId' });
    }
  },
});

// Utility to log errors and debugging messages
function handleError(error, functionName) {
  console.error(`Error in ${functionName}:`, error);
  throw new Error(`Failed in ${functionName}: ${error.message || error}`);
}

// Function to save data
export async function saveToIndexedDB(item) {
  try {
    if (!item || !item.uniqueCartId) {
      throw new Error('Item must have a uniqueCartId');
    }

    const db = await dbPromise;
    await db.put('cartAssets', item);
    console.info(`Successfully saved item with ID: ${item.uniqueCartId}`);
  } catch (error) {
    handleError(error, 'saveToIndexedDB');
  }
}

// Function to retrieve data
export async function getFromIndexedDB(uniqueCartId) {
  try {
    if (!uniqueCartId) {
      throw new Error('uniqueCartId is required');
    }

    const db = await dbPromise;
    const item = await db.get('cartAssets', uniqueCartId);

    if (!item) {
      console.warn(`No item found with ID: ${uniqueCartId}`);
    } else {
      console.info(`Retrieved item with ID: ${uniqueCartId}`);
    }

    return item;
  } catch (error) {
    handleError(error, 'getFromIndexedDB');
  }
}

// Function to delete data
export async function deleteFromIndexedDB(uniqueCartId) {
  try {
    if (!uniqueCartId) {
      throw new Error('uniqueCartId is required');
    }

    const db = await dbPromise;
    await db.delete('cartAssets', uniqueCartId);
    console.info(`Successfully deleted item with ID: ${uniqueCartId}`);
  } catch (error) {
    handleError(error, 'deleteFromIndexedDB');
  }
}

// Function to clear all data
export async function clearIndexedDB() {
  try {
    const db = await dbPromise;
    const tx = db.transaction('cartAssets', 'readwrite');
    await tx.store.clear();
    await tx.done;

    console.info('Successfully cleared all data from IndexedDB');
  } catch (error) {
    handleError(error, 'clearIndexedDB');
  }
}
